import { BMButton, BMPopup, BMText } from "@traveloka/district-bloom";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";

type Props = {
  visible?: boolean;
  isLoading?: boolean;
  onClose?: () => void;
};

export default function ExpiredModal({
  visible = true,
  isLoading = false,
  onClose = () => {},
}: Props) {
  const { CorporateFlightPrebookForm: cr } = useMobileContentResource();
  return (
    <BMPopup
      dismissible={false}
      isVisible={visible}
      onPopupClose={() => {}} // Disable default close on overlay press because dismissible is false
      title={cr.bookingExpiredModalTitle}
    >
      <BMView spacing="lg">
        <BMText variant="paragraphNormal">
          {cr.bookingExpiredModalDescription}
        </BMText>
        <BMButton
          size="LARGE"
          stretchable
          onPress={onClose}
          loading={isLoading}
          label={cr.bookingExpiredModalCta}
        />
      </BMView>
    </BMPopup>
  );
}
